// Data management utilities for import/export functionality

export const exportAppData = (appState) => {
  const dataToExport = {
    version: "1.0",
    exportDate: new Date().toISOString(),
    data: {
      operations: appState.operations || [],
      currentPrices: appState.currentPrices || {},
      investorProfile: appState.investorProfile || 'moderate',
      goals: appState.goals || [],
      simulationSettings: {
        initialCapital: appState.initialCapital || 15000000,
        monthlyContribution: appState.monthlyContribution || 450000,
        expectedReturn: appState.expectedReturn || 8.5,
        horizon: appState.horizon || 5
      },
      usdClpRate: appState.usdClpRate || 942.50,
      currency: appState.currency || 'USD'
    }
  };

  const dataStr = JSON.stringify(dataToExport, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(dataBlob);
  link.download = `equity-reserve-backup-${new Date().toISOString().split('T')[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const importAppData = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const importedData = JSON.parse(e.target.result);

        // Validate data structure
        if (!importedData.data) {
          throw new Error('Invalid file format: missing data section');
        }

        // Validate version compatibility
        if (importedData.version && importedData.version !== "1.0") {
          console.warn('Importing data from different version:', importedData.version);
        }

        resolve(importedData.data);
      } catch (error) {
        reject(new Error('Invalid JSON file or corrupted data: ' + error.message));
      }
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};

export const saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
};

export const loadFromLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error('Failed to load from localStorage:', error);
    return defaultValue;
  }
};

export const clearLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Failed to clear localStorage:', error);
  }
};